var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#ffffff;stroke-width:1.3439999999999999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st1{fill:none;stroke:#ffffff;stroke-width:1.3439999999999999;stroke-linecap:round;stroke-linejoin:round;} .st2{fill:none;stroke:#ffffff;stroke-width:1.3439999999999999;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:5.2066,0;} "), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 11,
    x2: 29,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7,
    y1: 8,
    x2: 7,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    y1: 8,
    x2: 10,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 8,
    x2: 13,
    y2: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    className: "st0",
    width: 26,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    className: "st0",
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 21,
    className: "st0",
    width: 7,
    height: 3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20,
    y1: 15,
    x2: 26,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23,
    y1: 18,
    x2: 26,
    y2: 18
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "6,22 12,19 16,22 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9,
    y1: 17,
    x2: 9,
    y2: 17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem4);
export default __webpack_public_path__ + "static/media/item4.15562784f3c1d2fc1f1b8d3113e48b50.svg";
export { ForwardRef as ReactComponent };